// extracted by mini-css-extract-plugin
export var actionBox = "recipe-card-module--action-box--c964c";
export var addButton = "recipe-card-module--add-button--e031e";
export var aiBadge = "recipe-card-module--ai-badge--def03";
export var card = "recipe-card-module--card--e97a3";
export var headerLink = "recipe-card-module--header-link--bb95f";
export var img = "recipe-card-module--img--14789";
export var imgLink = "recipe-card-module--img-link--a1e48";
export var imgWrapper = "recipe-card-module--img-wrapper--be07d";
export var lockBox = "recipe-card-module--lock-box--5032c";
export var lockLayer = "recipe-card-module--lock-layer--c65c7";
export var metadata = "recipe-card-module--metadata--c174d";
export var ratioClass = "recipe-card-module--ratio-class--8ff96";
export var title = "recipe-card-module--title--115be";